import { DocumentSnapshot } from '../FirestoreTypes';
import { BaseDocument } from './BaseDocument';
import { MedicationSchema } from '../schemas/Medication';

export class MedicationDocument extends BaseDocument<MedicationSchema> {
    constructor(snapshot: DocumentSnapshot<MedicationSchema>) {
        super(snapshot, 'Medication');
    }
}
